import classNames from "classnames";
import ViewAll from "component/design-system/ViewAll";
import PAText from "component/design-system/typography/PAText/PAText";
import ProductSliderCard from "container/manufacturer/ProductSliderCard";
import { useTranslation } from "next-i18next";
import styles from "./showRecentViewed.module.scss";

function ShowRecentViewed(props: any) {
  const { t } = useTranslation("common");
  const { products, sideBarHandler, productPage = false } = props;

  return (
    <div className={classNames(styles.product_recently_viewed, {
      [styles.recently_viewed_product]: productPage,
    })}
    >
      <div className={styles.recently_viewed_header}>
        <div className={`${styles.items_header} items-header`}>
          <legend className="d-flex align-items-center">
            <PAText
              component="h2"
              className="product_common_title"
              inlineBlock
              bold
            >
              {t("Recently Viewed By You")}

            </PAText>
          </legend>
        </div>
        <div className={styles.recent_viewall_link}>
          <ViewAll
            href="/predictive-viewall"
            title="Browse Your Recent Search Activity"
          />
        </div>
      </div>

      <div className={styles.recently_viewed_slider}>
        {products.map(((product, index) => (
          <ProductSliderCard key={index} product={product} sideBarHandler={sideBarHandler} />
        )))}
      </div>
    </div>
  );
}

export default ShowRecentViewed;
